<div class="outerContainer">

<h2 class="legendHeader">
    <div>Cycles</div>
    <div class="legend">
        <div class="unit-circle completed legend-circle"></div>
        <div class="legend-label">Completed</div>
        <div class="unit-circle in-progress legend-circle"></div>
        <div class="legend-label">Current</div>
    </div>
</h2>
<div class="m-4">
    <div *ngFor="let unit of strand.Units" (click)="selectUnit(unit)" class="mr-2 mb-2"
        [ngClass]="getUnitCircleClass(unit)">
        {{ unit.UnitNumber }}
    </div>
</div>
<hr class="major-divider">
<!-- unit report here-->
<app-strand-unit-report [studentID]="studentId" [courseCode]="strand.CourseCode" [unitNumber]="selectedUnitNumber">
</app-strand-unit-report>
</div>